
export {} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$loading-indicator.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$loading-indicator.js';export default __x__;